/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createPagedResultOfStorefrontUserResponseFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type PagedResultOfStorefrontUserResponse } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/storefront-users
 */
export interface StorefrontUsersRequestBuilder extends BaseRequestBuilder<StorefrontUsersRequestBuilder> {
    /**
     * List the users who have storefront access in an organization, one row per user, each with the customers they can shop for. Supports paging, sorting, free-text search across user and customer details, an exact CustomerNumber filter for answering "who can shop for this customer?", and a MissingCustomersOnly filter for finding access that points at a customer which no longer exists.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PagedResultOfStorefrontUserResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 409 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<StorefrontUsersRequestBuilderGetQueryParameters> | undefined) : Promise<PagedResultOfStorefrontUserResponse | undefined>;
    /**
     * List the users who have storefront access in an organization, one row per user, each with the customers they can shop for. Supports paging, sorting, free-text search across user and customer details, an exact CustomerNumber filter for answering "who can shop for this customer?", and a MissingCustomersOnly filter for finding access that points at a customer which no longer exists.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<StorefrontUsersRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * List the users who have storefront access in an organization, one row per user, each with the customers they can shop for. Supports paging, sorting, free-text search across user and customer details, an exact CustomerNumber filter for answering "who can shop for this customer?", and a MissingCustomersOnly filter for finding access that points at a customer which no longer exists.
 */
export interface StorefrontUsersRequestBuilderGetQueryParameters {
    /**
     * Optional exact customer number. Restricts the listing to users who can shop for thatcustomer — this is what powers the "Storefront Access" section on Customer Details.Returned rows still list every customer the user can access, not just this one.
     */
    customerNumber?: string;
    /**
     * When true, restricts the listing to users holding access to a customer that no longer exists.
     */
    missingCustomersOnly?: boolean;
    /**
     * Gets or sets the page number for the request. Default value is 1.
     */
    pageNumber?: number;
    /**
     * Gets or sets the page size for the request. Default value is 25.
     */
    pageSize?: number;
    /**
     * Rebuild the organization's storefront-access data rather than serving the cached copy.
     */
    refresh?: boolean;
    /**
     * Optional free-text search. Matches (case-insensitively, anywhere in the value) the user'sfirst name, last name, full name or email, and the customer number or company name of anycustomer they can shop for.
     */
    search?: string;
    /**
     * Gets or sets the sort direction. Can be "ASC" or "DESC". Default value is "asc".
     */
    sortDirection?: string;
    /**
     * Gets or sets the field to sort on. One of "Name", "Email" or "JoinedOn".Default value is "Name".
     */
    sortOn?: string;
}
/**
 * Uri template for the request builder.
 */
export const StorefrontUsersRequestBuilderUriTemplate = "{+baseurl}/api/organizations/storefront-users?pageNumber={pageNumber}&pageSize={pageSize}&sortDirection={sortDirection}&sortOn={sortOn}{&customerNumber*,missingCustomersOnly*,refresh*,search*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const StorefrontUsersRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: StorefrontUsersRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPagedResultOfStorefrontUserResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
